import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { StyledOrderBlock, StyledBottomBlock } from "./style";
import rightArrow from "../../assets/images/right-arrow.png";
import { useDispatch, useSelector } from "react-redux";
import { getOrderDetailsByOrderId, resendMail, uploadVisaDocument } from "../../features/order/orderSlice";
import moment from "moment";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
import AddComment from "./AddComment/AddComment";
import MyModal from "../Modal/Modal";
import EmailContent from "./EmailContent/EmailContent";
import { convertToTitleCase, capitalizeFirstLetter, getPhoneCode } from "../../utils/utility";
import CustomDeclarationDetails from "./CustomDeclarationDetails";
import Declarations from "./Declarations";
import DefenceContent from "./DefenceContent/DefenceContent";
import TransactionModal from "./TransactionModal/TransactionModal";

const ViewOrders = () => {
    const dispatch = useDispatch();
    const { orderId } = useParams();
    const [show, setShow] = useState(false);
    const [showDefencePack, setShowDefencePack] = useState(false);
    const [showDefence, setShowDefence] = useState(false);
    const [showTransaction, setShowTransaction] = useState(false);

    const OrderDetails = useSelector((state) => state?.order?.orderDetails);

    const isLoading = useSelector((state) => state?.order?.loading);
    const [selectedData, setSelectedData] = useState({
        showData: false,
        dataId: 0,
    });
    const [emailId, setEmailId] = useState(OrderDetails?.email);
    const [orderid, setEmailIdOrderid] = useState(OrderDetails?.order_id);
    const [mailServiceProvider, setMailServiceProvider] = useState('AWS');

    const uploadSchema = yup.object({
        email: yup.string().required("Please enter your email"),
        fileUpload: yup.mixed().required("File is required"),
    });

    useEffect(() => {
        if (orderId) {
            dispatch(getOrderDetailsByOrderId(orderId));
        }

        document.title = "Cuba E-Ar";
    }, [dispatch, orderId]);

    useEffect(() => {
        if (
            (OrderDetails &&
                typeof OrderDetails !== "undefined" &&
                OrderDetails?.email &&
                typeof emailId === "undefined") ||
            orderId !== orderid
        ) {
            setEmailId(OrderDetails?.email);
        }
    }, [OrderDetails, orderid]);

    let defaultInitialValues = {
        orderId: OrderDetails?.order_id,
        email: "",
        fileUpload: "",
    };

    if (orderId !== null && orderId !== undefined && OrderDetails !== null) {
        defaultInitialValues = {
            orderId: OrderDetails?.order_id,
            email: OrderDetails?.email,
            fileUpload: "",
        };
    }

    let [initialValues, setInitialValues] = useState(defaultInitialValues);

    const { values, errors, handleBlur, handleSubmit, handleChange, setFieldValue, resetForm } = useFormik({
        initialValues: orderId !== null ? defaultInitialValues : initialValues,
        enableReinitialize: true,
        validationSchema: uploadSchema,
        onSubmit: (values) => {
            const data = new FormData();
            data.append("orderId", values.orderId);
            data.append("email", values.email);
            data.append("uploadVisaDoc", values.fileUpload);
            data.append("mailServiceProvider", mailServiceProvider);
            dispatch(uploadVisaDocument(data)).unwrap().then((res) => {
                resetForm();
                if (res.status === 1) {
                    toast.success(`${res.message}`, {
                        className: "toast-message",
                    });
                    dispatch(getOrderDetailsByOrderId(orderId));
                }
            });
        },
    });

    const handleResendMail = (e, serviceProvider) => {
        e.preventDefault();
        setMailServiceProvider(serviceProvider);
        const data = {
            orderId: OrderDetails?.order_id,
            email: emailId,
            mailServiceProvider: serviceProvider
        };
        dispatch(resendMail(data)).unwrap().then((res) => {
            if (res.status === 1) {
                toast.success(`${res.message}`, {
                    className: "toast-message",
                });
                dispatch(getOrderDetailsByOrderId(orderId));
            }
        });
    };


    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    {OrderDetails?.mailHistory?.length !== 0 && (
                        <StyledOrderBlock>
                            <h2>Email History</h2>
                            <div className="table-block table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "5%" }}>#</th>
                                            <th style={{ width: "10%" }}>Order ID</th>
                                            <th style={{ width: "30%" }}>Download</th>
                                            <th style={{ width: "25%" }}>Date & Time</th>
                                            <th style={{ width: "30%" }}>Mail Provider</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {OrderDetails?.mailHistory?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td className="font-normal">{item?.order_id}</td>
                                                    {OrderDetails?.uploadDoc?.length ? (
                                                        <td>
                                                            <a
                                                                href={
                                                                    OrderDetails?.length !== 0
                                                                        ? `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PUBLIC_UPLOAD_PATH
                                                                        }docs/${OrderDetails?.order_id}_${item?.uploadDoc == null
                                                                            ? OrderDetails?.uploadDoc[0]?.file1
                                                                            : item?.uploadDoc.file1
                                                                        }`
                                                                        : null
                                                                }
                                                                className="blue-btn"
                                                                download
                                                                rel="noreferrer"
                                                            >
                                                                Download File{" "}
                                                            </a>
                                                        </td>
                                                    ) : (
                                                        ""
                                                    )}
                                                    <td>
                                                        {moment(item?.create_ts).format(
                                                            "MM/DD/YYYY h:mm:ss"
                                                        )}
                                                    </td>
                                                    <td>{item?.uploadDoc?.mail_service_provider}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                <form className="form-inline">
                                    <div className="form-group">
                                        <label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="form-control input-class"
                                                value={emailId}
                                                onChange={(e) => setEmailId(e.target.value)}
                                            />
                                        </label>
                                    </div>
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="blue-btn"
                                            id="download_btn"
                                            disabled={isLoading}
                                            onClick={(e) => {
                                                handleResendMail(e, "AWS");
                                            }}
                                        >
                                            Resend Mail(AWS){" "}
                                            <span>
                                                <img src={rightArrow} alt="rightArrow" />
                                            </span>
                                        </button>

                                        <button
                                            type="button"
                                            className="blue-btn"
                                            id="download_btn_sendgrid"
                                            disabled={isLoading}
                                            onClick={(e) => {
                                                handleResendMail(e, "Sendgrid");
                                            }}
                                        >
                                            Resend Mail(Sendgrid){" "}
                                            <span>
                                                <img src={rightArrow} alt="rightArrow" />
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </StyledOrderBlock>
                    )}
                </div>
                <div className="col-md-12">
                    <StyledOrderBlock>
                        <h2>Upload Document</h2>
                        <div className="table-block table-responsive fw-mobileview">
                            <form onSubmit={handleSubmit}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "15%" }}>Order ID</td>
                                            <td style={{ width: "35%" }} className="font-normal">
                                                <input
                                                    type="text"
                                                    name="orderId"
                                                    className="form-control"
                                                    placeholder="Order ID"
                                                    disabled
                                                    value={values?.orderId}
                                                />
                                            </td>
                                            <td style={{ width: "15%" }}>Email ID</td>
                                            <td style={{ width: "35%" }}>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    value={values?.email}
                                                    onChange={handleChange}
                                                    placeholder="Email"
                                                />
                                                <p>{errors.email}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>PDF</td>
                                            <tr>
                                                <td>
                                                    <label className="file-upload">
                                                        <input
                                                            type="file"
                                                            className=""
                                                            id="fileUpload"
                                                            name="fileUpload"
                                                            accept=".pdf,image/*"
                                                            onChange={(e) =>
                                                                setFieldValue(
                                                                    "fileUpload",
                                                                    e.currentTarget.files[0]
                                                                )
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                        <span>Choose File</span>
                                                    </label>
                                                    <span className="slcted-file"></span>
                                                    <p>{errors.fileUpload}</p>
                                                </td>
                                            </tr>
                                        </tr>
                                        {OrderDetails?.uploadDoc?.length ? (
                                            <td colSpan="2">
                                                <a
                                                    href={
                                                        OrderDetails?.length !== 0
                                                            ? `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PUBLIC_UPLOAD_PATH}docs/${OrderDetails?.uploadDoc[0]?.file1}`
                                                            : null
                                                    }
                                                    className="blue-btn"
                                                    download
                                                    rel="noreferrer"
                                                >
                                                    Download File{" "}
                                                </a>
                                            </td>
                                        ) : (
                                            ""
                                        )}
                                    </tbody>
                                </table>
                                <br />
                                <button
                                    type="submit"
                                    className="blue-btn"
                                    id="submit_btn"
                                    disabled={isLoading}
                                    onClick={() => setMailServiceProvider('AWS')}
                                >
                                    Submit (AWS){" "}
                                    <span>
                                        <img src={rightArrow} alt="rightArrow" />
                                    </span>
                                </button>
                                <button
                                    type="submit"
                                    className="blue-btn"
                                    id="submit_btn_sendgrid"
                                    disabled={isLoading}
                                    onClick={() => setMailServiceProvider('Sendgrid')}
                                >
                                    Submit (SendGrid){" "}
                                    <span>
                                        <img src={rightArrow} alt="rightArrow" />
                                    </span>
                                </button>
                            </form>
                        </div>
                    </StyledOrderBlock>
                </div>
                <div className="col-md-12">

                    <StyledOrderBlock>
                        <h2>Order Details</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.order_id && (
                                        <tr>
                                            <td>Order ID:</td>
                                            <td>{OrderDetails?.order_id}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.order_id && (
                                        <tr>
                                        <td>Application Email Address</td>
                                        <td>{`${OrderDetails?.order_id}@officesend.com`}</td>
                                        </tr>
                                    )}
                                    {typeof OrderDetails?.email != "undefined" && (
                                        <tr>
                                            <td>Email Address</td>
                                            <td>{OrderDetails?.email}</td>
                                        </tr>
                                    )}

                                    {typeof OrderDetails?.processing_mode != "undefined" && (
                                        <tr>
                                            <td>Processing Mode</td>
                                            <td>{OrderDetails?.processing_mode == "Regular Processing" ? "Standard Processing" : OrderDetails?.processing_mode}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.signature_name && (
                                        <tr>
                                            <td>Signature Name</td>
                                            <td>{OrderDetails?.signature_name}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Personal Data</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    
                                    
                                    {OrderDetails?.first_name && (
                                        <tr>
                                            <td>First Name</td>
                                            <td>{OrderDetails?.first_name}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.second_name && (
                                        <tr>
                                            <td>Second Name</td>
                                            <td>{OrderDetails?.second_name}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.sur_name && (
                                        <tr>
                                            <td>First Surname</td>
                                            <td>{OrderDetails?.sur_name}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.second_sur_name && (
                                        <tr>
                                            <td>Second Surname</td>
                                            <td>{OrderDetails?.second_sur_name}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.date_of_birth && (
                                        <tr>
                                            <td>Birth Date (DD/MM/YYYY)</td>
                                            <td>{OrderDetails?.date_of_birth ? moment(OrderDetails?.date_of_birth).format('DD/MM/YYYY') : ""}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.gender && (
                                        <tr>
                                            <td>Sex</td>
                                            <td>{OrderDetails?.gender}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.citizenship && (
                                        <tr>
                                            <td>Citizenship</td>
                                            <td>{OrderDetails?.citizenship}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.passport_number && (
                                        <tr>
                                            <td>Passport number </td>
                                            <td>{OrderDetails?.passport_number}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.country_of_permanent_residence && (
                                        <tr>
                                            <td>Country of permanent residence</td>
                                            <td>{OrderDetails?.country_of_permanent_residence}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.email && (
                                        <tr>
                                            <td> Email Address</td>
                                            <td>{OrderDetails?.email}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.confirm_email && (
                                        <tr>
                                            <td>Confirm Email Address</td>
                                            <td>{OrderDetails?.confirm_email}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.phone_number && OrderDetails?.country_code && (
                                        <tr>
                                            <td>Mobile Number</td>
                                            <td>{`+${getPhoneCode(OrderDetails?.country_code)} ${OrderDetails?.phone_number}`}</td>
                                        </tr>
                                    )}
                                   
                                    
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>
                    <StyledOrderBlock>
                        <h2>Migratory Information</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.date_of_arrival && (
                                        <tr>
                                            <td>Arrival date (DD/MM/YYYY)</td>
                                            <td>{OrderDetails?.date_of_arrival? moment(OrderDetails?.date_of_arrival).format('DD/MM/YYYY') : ""}</td>
                                        </tr>
                                    )}
                                     {OrderDetails?.flight && (
                                        <tr>
                                            <td>Flight</td>
                                            <td>{OrderDetails?.flight}</td>
                                        </tr>
                                    )}
                                     {OrderDetails?.airline_name && (
                                        <tr>
                                            <td>Airline Name</td>
                                            <td>{OrderDetails?.airline_name}</td>
                                        </tr>
                                    )}
                                     {OrderDetails?.country_of_origin && (
                                        <tr>
                                            <td>Traveler's country of origin </td>
                                            <td>{OrderDetails?.country_of_origin}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.port_of_entry && (
                                        <tr>
                                            <td>Airport/Port of entry to Cuba</td>
                                            <td>{OrderDetails?.port_of_entry}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.travel_reasons && (
                                        <tr>
                                            <td>Travel reasons</td>
                                            <td>{OrderDetails?.travel_reasons}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.electronic_visa_number && (
                                        <tr>
                                            <td>Electronic Visa Number</td>
                                            <td>{OrderDetails?.electronic_visa_number}</td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Sanitary Information</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.place_of_accommodation && (
                                        <tr>
                                            <td>Place of accommodation</td>
                                            <td>{capitalizeFirstLetter(OrderDetails?.place_of_accommodation)}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.name_of_hotel && OrderDetails?.place_of_accommodation=='Hotel' && (
                                        <tr>
                                            <td>Name of the hotel</td>
                                            <td>{OrderDetails?.name_of_hotel}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.name_of_hotel &&OrderDetails?.name_of_hotel=='Other' && OrderDetails?.place_of_accommodation=='Hotel' && OrderDetails?.other_hotel && (
                                        <tr>
                                            <td>Other hotel</td>
                                            <td>{OrderDetails?.other_hotel}</td>
                                        </tr>
                                    )}

                                    {OrderDetails?.traveler_address && (OrderDetails?.place_of_accommodation=='Home'||OrderDetails?.place_of_accommodation=='House or room for rent') && (
                                        <tr>
                                            <td>Traveler address</td>
                                            <td>{OrderDetails?.traveler_address}</td>
                                        </tr>
                                    )}
                                    
                                    {OrderDetails?.province && (OrderDetails?.place_of_accommodation=='Home'||OrderDetails?.place_of_accommodation=='House or room for rent') && (
                                        <tr>
                                            <td>Province where you are going</td>
                                            <td>{OrderDetails?.province}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.municipality && (OrderDetails?.place_of_accommodation=='Home'||OrderDetails?.place_of_accommodation=='House or room for rent') && (
                                        <tr>
                                            <td>Municipality where you are going</td>
                                            <td>{OrderDetails?.municipality}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.countries_visited &&  (
                                        <tr>
                                            <td>Countries visited in the last 15 days</td>
                                            <td>{OrderDetails?.countries_visited}</td>
                                        </tr>
                                    )}
                                    {OrderDetails?.symptoms &&  (
                                        <tr>
                                            <td>Symptoms or signs of illness in the last 15 days </td>
                                            <td>{OrderDetails?.symptoms}</td>
                                        </tr>
                                    )}
                                    
                                    
                                    
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Customs Information</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <tbody>
                                    {OrderDetails?.declare_at_customs && (
                                        <tr>
                                            <td colSpan="2">Do you have something to declare at customs?</td>
                                            <td colSpan="2" >{capitalizeFirstLetter(OrderDetails?.declare_at_customs.replace(/_/g, ' '))}</td>
                                        </tr>
                                    )}
                                    <>
                                    <tr>
                                        <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left" }}>
                                           
                                        </td>
                                    </tr>
                                    

                                    {OrderDetails?.currency_details && OrderDetails?.currency_details!='' && Array.isArray(OrderDetails.currency_details) && (
                                        <>
                                        <tr>
                                        <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left" }}>
                                            The import of freely convertible currency (MLC) is free. Declare the total amount when it is greater than five thousand United States dollars (USD 5000) or its equivalent in other MLCs in cash or security.
                                        </td>
                                    </tr>
                                            <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                                                <td>Currency</td>
                                                <td></td>
                                                <td>Amount</td>
                                                <td></td>
                                            </tr>

                                            {OrderDetails.currency_details.map((currencyDetail, index) => (
                                                <tr key={index}>
                                                    <td>{currencyDetail?.currency}</td>
                                                    <td></td>
                                                    <td>{currencyDetail?.amount}</td>
                                                    <td></td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </>
                                <>
                                   <tr>
                                        <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left" }}>
                                           
                                        </td>
                                    </tr>
                                        
                                        {OrderDetails?.declare_at_customs === "yes" && (
                                            <>
                                                <tr>
                                                    <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left", padding: "10px 0" }}>
                                                        Besides your personal belongings, you bring in some miscellaneous such as footwear, clothing, foodstuffs, personal hygiene and household goods, custom jewelry, lingerie, toiletries, and other related articles worth up to one thousand US dollars (USD 1000).
                                                    </td>
                                                </tr>

                                                {(OrderDetails?.personal_belongings_amount || OrderDetails?.luggage_items) && (
                                                    <>
                                                        <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                                                            <td>Amount</td>
                                                            <td></td>
                                                            <td>Items You Bring with You or in Your Luggage</td>
                                                            <td></td>
                                                        </tr>

                                                        <tr>
                                                            <td>{OrderDetails?.personal_belongings_amount || "N/A"}</td>
                                                            <td></td>
                                                            <td>{OrderDetails?.luggage_items || "N/A"}</td>
                                                            <td></td>
                                                        </tr>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    
                                       
                                        {OrderDetails?.declare_at_customs === "yes" && OrderDetails?.category_details?.length > 0 && (
                                            <>
                                            <tr>
                                        <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left" }}>
                                           
                                        </td>
                                    </tr>
                                                <tr>
                                                    <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left", padding: "10px 0" }}>
                                                        List of equipment and items (household appliances and others) that you bring, which are not classified as miscellaneous.
                                                    </td>
                                                </tr>

                                                <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                                                    <td>Category</td>
                                                    <td>Article</td>
                                                    <td>Quantity</td>
                                                    <td>Amount</td>
                                                </tr>

                                                {OrderDetails?.category_details.map((categoryDetail, index) => (
                                                    <tr key={index}>
                                                        <td>{categoryDetail?.category || "N/A"}</td>
                                                        <td>{categoryDetail?.article || "N/A"}</td>
                                                        <td>{categoryDetail?.quantity || "N/A"}</td>
                                                        <td>{categoryDetail?.amount || "N/A"}</td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                    </>
                                    <tr>
                                        <td colSpan="4" style={{ fontWeight: "bold", textAlign: "left" }}>
                                           
                                        </td>
                                    </tr>
                                    {OrderDetails?.technical_authorization_number && (
                                        <tr>
                                            <td colSpan="2">MINCOM's Import Technical Authorization Number</td>
                                            <td colSpan="2" >{capitalizeFirstLetter(OrderDetails?.technical_authorization_number.replace(/_/g, ' '))}</td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>

                    <StyledOrderBlock>
                        <h2>Download History</h2>
                        <div className="table-block table-responsive">
                            <table width="100%">
                                <thead>
                                    <tr>
                                        <th width="5%">#</th>
                                        <th width="10%">Order ID</th>
                                        <th width="22%">Date & Time</th>
                                        <th width="23%">Downloaded File</th>
                                        <th width="20%">IP Address</th>
                                        <th width="20%">Location</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {OrderDetails?.downloadHistory ? (
                                        OrderDetails?.downloadHistory?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.order_id}</td>
                                                    <td>
                                                        {moment(item?.create_ts).format(
                                                            "MM/DD/YYYY hh:mm:ss"
                                                        )}{" "}
                                                        EST
                                                    </td>
                                                    <td>
                                                        {OrderDetails?.uploadDoc?.length !== 0 && (
                                                            <a
                                                                href={
                                                                    OrderDetails?.uploadDoc !== undefined
                                                                        ? `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_PUBLIC_UPLOAD_PATH}visaDocs/${OrderDetails?.uploadDoc[0]?.file1}`
                                                                        : null
                                                                }
                                                                className="blue-btn"
                                                                target="_blank"
                                                                // download
                                                                rel="noreferrer"
                                                            >
                                                                Download File
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>{item?.ip}</td>
                                                    <td>{item?.timezone}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" align="center">
                                                No record found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <form className="form-inline">
                                <div className="form-group">
                                    <label>
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            className="form-control input-class"
                                            value={emailId}
                                            onChange={(e) => setEmailId(e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className="blue-btn"
                                        id="download_btn"
                                        onClick={handleResendMail}
                                        disabled={isLoading}
                                    >
                                        Sent Mail{" "}
                                        <span>
                                            <img src={rightArrow} alt="rightArrow" />
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </StyledOrderBlock>
                    <AddComment />
                    <StyledOrderBlock>
                        <h2>Comment History</h2>
                        <div className="table-block table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="10%">#</th>
                                        <th width="20%">Order ID</th>
                                        <th width="20%">Date & Time</th>
                                        <th width="15%">Team</th>
                                        <th width="35%">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {typeof OrderDetails !== "undefined" &&
                                        OrderDetails.remark ? (
                                        OrderDetails.remark?.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>{item?.order_id}</td>
                                                    <td>
                                                        {moment(item?.us_date).format("MM/DD/YYYY")}
                                                        {"  "}
                                                        {item?.us_time}
                                                    </td>
                                                    <td>{item?.remark_name}</td>
                                                    <td>
                                                        {selectedData.showData &&
                                                            selectedData.dataId === item.id ? (
                                                            <div
                                                                rel="40"
                                                                className="btn blue-btn"
                                                                onClick={() =>
                                                                    setSelectedData({
                                                                        showData: !selectedData.showData,
                                                                        dataId: item?.id,
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                Hide
                                                            </div>
                                                        ) : (
                                                            <div
                                                                rel="40"
                                                                onClick={() =>
                                                                    setSelectedData({
                                                                        showData: !selectedData.showData,
                                                                        dataId: item?.id,
                                                                    })
                                                                }
                                                                className="btn blue-btn"
                                                            >
                                                                {" "}
                                                                Show
                                                            </div>
                                                        )}
                                                        <br />
                                                        {selectedData.showData &&
                                                            selectedData.dataId === item.id && (
                                                                <div id="40">
                                                                    <textarea
                                                                        name="remark"
                                                                        className="form-control"
                                                                        defaultValue={item?.remark}
                                                                    ></textarea>
                                                                    <b>
                                                                        Whatsapp:
                                                                        {item?.whatsapp ? item?.whatsapp : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Telephone:
                                                                        {item?.telephone ? item?.telephone : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Refund:
                                                                        {item?.status_refund
                                                                            ? item?.status_refund
                                                                            : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Voided:
                                                                        {item?.voided ? item?.voided : "N"}
                                                                    </b>
                                                                    <b>
                                                                        Chargeback:
                                                                        {item?.chargeback ? item?.chargeback : "N"}
                                                                    </b>
                                                                    <b>
                                                                        ReportError:
                                                                        {item?.report_error
                                                                            ? item?.report_error
                                                                            : "N"}
                                                                    </b>
                                                                </div>
                                                            )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="5" align="center">
                                                No record found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </StyledOrderBlock>
                </div>

                <StyledBottomBlock>
                    <button
                        type="button"
                        className="blue-btn"
                        data-toggle="modal"
                        data-target="#refundModal"
                        onClick={() => setShow(true)}
                    >
                        View Email Content{" "}
                    </button>

                   
                    {(OrderDetails?.process_status == "Completed" || OrderDetails?.process_status == "Customer Called"|| OrderDetails?.process_status == "ChargeBack") && (
                        <>
                            <button
                                type="button"
                                className="blue-btn"
                                data-toggle="modal"
                                data-target="#defencePackModal"
                                onClick={() => setShowDefence(true)}
                            >
                                Defence Pack 1{" "}
                                <span>
                                    <img src={rightArrow} alt="rightArrow" />
                                </span>
                            </button>
                            <button
                                type="button"
                                className="blue-btn"
                                data-toggle="modal"
                                data-target="#defencePackModal1"
                                onClick={() => setShowDefencePack(true)}
                            >
                                Defence Pack 2{" "}
                                <span>
                                    <img src={rightArrow} alt="rightArrow" />
                                </span>
                            </button>

                            <button
                                type="button"
                                className="blue-btn"
                                data-toggle="modal"
                                data-target="#defencePackModal"
                                onClick={() => setShowTransaction(true)}
                            >
                                Enter Transaction Details {" "}
                            </button>
                        </>
                    )} 

                    <MyModal
                        show={show}
                        close={setShow}
                        size={"lg"}
                        modalHeadTitle={"Email Content"}
                        showFooter={true}
                        primaryButtonName={"Close"}
                        secondaryButtonName={"Send Whatsapp Message"}
                        OrderDetails={OrderDetails}
                    >
                        <EmailContent />
                    </MyModal>

                    <MyModal
                        show={showDefence}
                        close={setShowDefence}
                        size={"lg"}
                        modalHeadTitle={"Defence Pack Content"}
                        showFooter={false}
                        OrderDetails={OrderDetails}
                    >
                        <DefenceContent defencePackName={null} />
                    </MyModal>
                    <MyModal
                        show={showDefencePack}
                        close={setShowDefencePack}
                        size={"lg"}
                        modalHeadTitle={"Defence Pack Content"}
                        showFooter={false}
                        OrderDetails={OrderDetails}
                    >
                        <DefenceContent defencePackName={"defencePack1"} />
                    </MyModal>

                    <MyModal
                        show={showTransaction}
                        close={setShowTransaction}
                        size={"s"}
                        modalHeadTitle={"Enter Defence Pack Details:"}
                        showFooter={false}
                        OrderDetails={OrderDetails?.length > 0 ? OrderDetails[0] : ""}
                    >
                        <TransactionModal setShowTransaction={setShowTransaction} />
                    </MyModal>

                </StyledBottomBlock>
            </div>
        </>
    );
};

export default ViewOrders;
